var map = {
	"./backgruond.png": 101,
	"./bronze-plate.png": 35,
	"./bubble-left.png": 21,
	"./bubble-right.png": 102,
	"./champions.png": 26,
	"./continue-play.png": 44,
	"./gold-plate.png": 27,
	"./gray-frame-btn.png": 103,
	"./gray-plate.png": 28,
	"./instructions-logo.png": 104,
	"./instructions.png": 105,
	"./logo.png": 24,
	"./losing.png": 106,
	"./mute-icon.png": 33,
	"./my-plate.png": 41,
	"./pink-btn.png": 40,
	"./pink-frame.png": 107,
	"./prev-arrow.png": 42,
	"./prev-arrow_.png": 108,
	"./red-timer.png": 109,
	"./sound-icon.png": 34,
	"./start-arrow.png": 32,
	"./stop.png": 45,
	"./timer.png": 110,
	"./winning.png": 111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43;